export type Range = [number, number]

/**
 * Seconds kept behind the frame being watched. A browser removes a range up
 * to the next keyframe, so a trim must end at least a keyframe interval
 * before playback; UniFi cameras send one every 5s. At 7 Mbps this is about
 * 26 MB, well inside a browser's buffer quota.
 */
export const KEEP_BEHIND = 30
// Removed only once this much more has gathered, so not on every append.
const TRIM_STEP = 10
// How far playback may fall behind the live edge before it is moved up to it.
const MAX_LAG = 5
const LIVE_EDGE = 0.5

/**
 * What a live player should do with its buffer: what to remove, and where to
 * move playback. Every seek lands inside a buffered range.
 */
export function trimPlan(buffered: Range[], currentTime: number): { remove?: Range; seekTo?: number } {
  if (buffered.length === 0) return {}
  const start = buffered[0][0]
  const [lastStart, end] = buffered[buffered.length - 1]
  const plan: { remove?: Range; seekTo?: number } = {}

  const keepFrom = currentTime - KEEP_BEHIND
  if (keepFrom - start >= TRIM_STEP) plan.remove = [start, keepFrom]

  const playable = buffered.some(([s, e]) => currentTime >= s && currentTime <= e)
  if (!playable || end - currentTime > MAX_LAG) {
    plan.seekTo = Math.max(lastStart, end - LIVE_EDGE)
  }
  return plan
}
